import React from 'react';
import PropTypes from 'prop-types';
import Avatar from 'react-avatar';
import { BADGE_CONFIG, STATUS_TEXT_MAP } from '../relationships/constants';

const getOrgSource = (row = {}) => (
  row?.destination_org || row?.DestinationOrg || row?.organization || row?.Organization || row
);

const formatAddress = (row = {}, orgInfo = {}) =>
  [
    row?.City || row?.city || orgInfo?.City || orgInfo?.city,
    row?.State || row?.state || orgInfo?.State || orgInfo?.state,
    row?.Zip || row?.zip || orgInfo?.Zip || orgInfo?.zip,
    row?.County || row?.county || orgInfo?.County || orgInfo?.county,
    row?.address_line1 || row?.AddressLine1 || row?.address1 || row?.Address1 ||
    orgInfo?.address_line1 || orgInfo?.AddressLine1 || orgInfo?.address1 || orgInfo?.Address1,
    row?.address_line2 || row?.AddressLine2 || row?.address2 || row?.Address2 ||
    orgInfo?.address_line2 || orgInfo?.AddressLine2 || orgInfo?.address2 || orgInfo?.Address2
  ]
    .filter(Boolean)
    .join(', ');

const getNormalizedStatus = (row = {}) => {
  const orgInfo = getOrgSource(row);
  const rawStatus =
    row?.status ||
    row?.requestStatus ||
    row?.RequestStatus ||
    row?.request_status ||
    row?.B2BStatus ||
    row?.b2bStatus ||
    row?.b2b_status ||
    row?.RelationshipStatus ||
    row?.relationshipStatus ||
    row?.relationship_status ||
    orgInfo?.status ||
    orgInfo?.requestStatus ||
    orgInfo?.RequestStatus ||
    orgInfo?.request_status ||
    orgInfo?.B2BStatus ||
    orgInfo?.b2bStatus ||
    orgInfo?.b2b_status ||
    orgInfo?.RelationshipStatus ||
    orgInfo?.relationshipStatus ||
    orgInfo?.relationship_status ||
    '';

  return String(rawStatus).toUpperCase();
};

const OrganisationInfo = ({ row = {}, showSelectedTick = false, showStatus = true }) => {
  const orgInfo = getOrgSource(row);
  const name =
    row?.OrganizationName ||
    row?.Name ||
    row?.name ||
    orgInfo?.OrganizationName ||
    orgInfo?.Name ||
    orgInfo?.name ||
    '';

  const address = formatAddress(row, orgInfo);
  const status = getNormalizedStatus(row);
  const requestBadge = BADGE_CONFIG[status];
  const requestBadgeText = STATUS_TEXT_MAP[status];
  const initials = name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0))
    .join('')
    .toUpperCase();

  return (
    <div className="changeOwner">
      <div className="rowFlex alignMiddle userPic">
        <Avatar
          size="36"
          round="100%"
          name={name}
          initials={initials || name.charAt(0)}
          maxInitials={2}
        />
        <div className="colFlex ml">
          <div className="userInfo aligneMiddle">
            <span>{name}</span>
            {showStatus && requestBadgeText && (
              <span className={`ml status statusFilled workkardStatus ${requestBadge?.className || 'excluded excludedFilled'}`}>
                {requestBadgeText}
              </span>
            )}
          </div>

          <label>{address}</label>

        </div>
        {showSelectedTick && (
          <span
            className="badges checked selectChecked green"
            style={{ marginLeft: 'auto', alignSelf: 'center' }}
          />
        )}
      </div>
    </div>
  );
};

OrganisationInfo.propTypes = {
  row: PropTypes.object,
  showSelectedTick: PropTypes.bool,
  showStatus: PropTypes.bool,
};

export default OrganisationInfo;
